import React, {Component} from 'react';
import icon from '../../images/shield-1086703_1280.png';

export default class BanerHome extends Component {
  render() {
    return (
      <div>
        <section>
          <img className='icon' src={icon} alt='' />
          <h1 className='welcome'>the future</h1>
          <div className='wave wave1'></div>
          <div className='wave wave2'></div>
          <div className='wave wave3'></div>
          <div className='wave wave4'></div>
        </section>
      </div>
    );
  }
}
